<template>
  <van-popup
    v-model="showContent"
    :get-container="getContainer"
    :transition-appear="true"
    :safe-area-inset-bottom="true"
    :close-on-click-overlay="maskClosable"
    @closed="closeModal"
  >
    <!-- <div class="modal-main bg-ele">
      <Back
        v-if="useBackBtn"
        class="modal-main-back"
        :disableRouteBack="true"
        @click="back"
      ></Back>
      <Close
        v-if="useCloseBtn"
        class="modal-main-close"
        @click="closeModal"
      ></Close>
      <slot></slot>
    </div> -->
    <transition name="scale-in" appear>
      <div v-if="showContent" class="modal-main bg-ele">
        <Back
          v-if="useBackBtn"
          class="modal-main-back"
          :disableRouteBack="true"
          @click="back"
        ></Back>
        <Close
          v-if="useCloseBtn"
          class="modal-main-close"
          @click="closeModal"
        ></Close>
        <slot></slot>
      </div>
    </transition>
  </van-popup>
</template>

<script>
import { Popup } from 'vant';

export default {
  name: 'Modal',
  emits: ['back', 'close', 'update:visible'],
  components: {
    Popup
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    // 是否需要返回按钮
    useBackBtn: {
      type: Boolean,
      default: false
    },
    // 是否需要右上角的关闭按钮
    useCloseBtn: {
      type: Boolean,
      default: true
    },
    // 点击蒙层是否允许关闭
    maskClosable: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    showContent: {
      get() {
        return this.visible;
      },
      set(bool) {
        this.$emit('update:visible', bool);
      }
    }
  },
  methods: {
    getContainer() {
      return document.querySelector('.official-passport-page');
    },
    closeModalByMask() {
      this.maskClosable && this.closeModal();
    },
    closeModal() {
      this.$emit('close');
      this.$emit('update:visible', false);
    },
    back() {
      this.$emit('back');
    }
  }
};
</script>

<style lang="scss" scoped>
.modal {
  z-index: 9;
  display: flex;
  justify-content: center;
  align-content: center;
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  &-hide {
    display: none;
  }
  &-shadow {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    width: 100%;
    height: 100%;
    background-color: rgba($color: #000000, $alpha: 0.4);
    cursor: pointer;
  }
  &-main {
    overflow: auto;
    position: relative;
    box-sizing: border-box;
    width: 630px;
    min-height: 260px;
    max-height: 100vh;
    margin: auto;
    padding: 50px 30px 30px;
    background-color: var(--page-bgColor);
    background-repeat: no-repeat;
    background-position: center 0;
    border-radius: var(--border-radius);

    &-back {
      position: absolute;
      top: 22px;
      left: 22px;
    }

    &-close {
      position: absolute;
      top: 22px;
      right: 22px;
    }
  }
}
</style>
